// Utility function to open chat widget
// This function attempts to open various popular chat widgets

export const openChat = () => {
  // Try Intercom
  if (window.Intercom) {
    window.Intercom('show');
    return;
  }

  // Try Crisp
  if (window.$crisp) {
    window.$crisp.push(['do', 'chat:open']);
    return;
  }

  // Try Drift
  if (window.drift) {
    window.drift.api.openChat();
    return;
  }

  // Try Tawk.to
  if (window.Tawk_API) {
    window.Tawk_API.maximize();
    return;
  }

  // Try LiveChat
  if (window.LC_API) {
    window.LC_API.open_chat_window();
    return;
  }

  // Try Zendesk (primary)
  if (window.zE) {
    try {
      window.zE('messenger', 'open');
      return;
    } catch (e) {
      console.log('Zendesk messenger error, trying webWidget');
      // Fallback for older Zendesk API
      if (window.zE.activate) {
        window.zE.activate();
        return;
      }
    }
  }

  // Fallback - show alert if no chat widget is detected
  console.log('No chat widget detected. Please add a chat integration.');
  alert('Chat feature is not configured yet. Please contact us at +1 833 201 7583 or email us.');
};
